export var Date;
(function (Date) {
    function is(value) {
        return (typeof value == "string" &&
            value.length == 10 &&
            new globalThis.Date(value).toString() != "Invalid Date" &&
            create(new globalThis.Date(value)) == value);
    }
    Date.is = is;
    function parse(value, time) {
        return new globalThis.Date(value + (time ?? "T12:00:00.000Z"));
    }
    Date.parse = parse;
    function create(value) {
        return value.toISOString().substring(0, 10);
    }
    Date.create = create;
    function now() {
        return create(new globalThis.Date());
    }
    Date.now = now;
    function localize(value, locale, timezone) {
        return ((is(value) ? parse(value) : value)
            .toLocaleString(locale ? locale : Intl.DateTimeFormat().resolvedOptions().locale, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
            .substring(0, 10)
            // See DateTime:localize for note.
            .replaceAll(" ", " "));
    }
    Date.localize = localize;
    function next(date, days = 1) {
        let result;
        if (typeof days == "number") {
            const r = parse(date);
            r.setDate(r.getDate() + days);
            result = Date.create(r);
        }
        else {
            result = date;
            if (days.years)
                result = nextYear(result, days.years);
            if (days.months)
                result = nextMonth(result, days.months);
            if (days.days)
                result = next(result, days.days);
        }
        return result;
    }
    Date.next = next;
    function previous(date, days = 1) {
        let result;
        if (typeof days == "number") {
            const r = parse(date);
            r.setDate(r.getDate() - days);
            result = Date.create(r);
        }
        else {
            result = date;
            if (days.years)
                result = previousYear(result, days.years);
            if (days.months)
                result = previousMonth(result, days.months);
            if (days.days)
                result = previous(result, days.days);
        }
        return result;
    }
    Date.previous = previous;
    function nextMonth(date, months = 1) {
        const result = parse(date);
        result.setMonth(result.getMonth() + months);
        return Date.create(result);
    }
    Date.nextMonth = nextMonth;
    function previousMonth(date, months = 1) {
        return nextMonth(date, -months);
    }
    Date.previousMonth = previousMonth;
    function nextYear(date, years = 1) {
        const result = parse(date);
        result.setFullYear(result.getFullYear() + years);
        return Date.create(result);
    }
    Date.nextYear = nextYear;
    function previousYear(date, years = 1) {
        return nextYear(date, -years);
    }
    Date.previousYear = previousYear;
    function firstOfYear(date) {
        const result = parse(date);
        result.setMonth(0);
        result.setDate(1);
        return Date.create(result);
    }
    Date.firstOfYear = firstOfYear;
    function lastOfYear(date) {
        const result = parse(date);
        result.setFullYear(result.getFullYear() + 1);
        result.setMonth(0);
        result.setDate(0);
        return Date.create(result);
    }
    Date.lastOfYear = lastOfYear;
    function firstOfMonth(date) {
        const result = parse(date);
        result.setDate(1);
        return Date.create(result);
    }
    Date.firstOfMonth = firstOfMonth;
    function lastOfMonth(date) {
        const result = parse(date);
        result.setMonth(result.getMonth() + 1);
        result.setDate(0);
        return Date.create(result);
    }
    Date.lastOfMonth = lastOfMonth;
    function firstOfWeek(date) {
        const result = parse(date);
        const relativeDay = result.getDate() - (result.getDay() || 7) + 1;
        result.setDate(relativeDay);
        return Date.create(result);
    }
    Date.firstOfWeek = firstOfWeek;
    function lastOfWeek(date) {
        const result = parse(date);
        const relativeDay = result.getDate() - result.getDay() + 7;
        result.setDate(relativeDay);
        return Date.create(result);
    }
    Date.lastOfWeek = lastOfWeek;
    function getYear(date) {
        return Number.parseInt(date.substring(0, 4));
    }
    Date.getYear = getYear;
    function getMonth(date) {
        return Number.parseInt(date.substring(5, 7));
    }
    Date.getMonth = getMonth;
    function getWeek(date) {
        const parsed = new globalThis.Date(date);
        parsed.setHours(0, 0, 0, 0);
        parsed.setDate(parsed.getDate() + 3 - ((parsed.getDay() + 6) % 7));
        const week1 = new globalThis.Date(parsed.getFullYear(), 0, 4);
        return 1 + Math.round(((parsed.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
    }
    Date.getWeek = getWeek;
    function getDay(date) {
        return Number.parseInt(date.substring(8, 10));
    }
    Date.getDay = getDay;
    function getWeekDay(date, locale, options) {
        const format = options?.format ?? "long";
        return locale
            ? new globalThis.Date(date).toLocaleDateString(locale, { weekday: format })
            : new globalThis.Date(date).getDay();
    }
    Date.getWeekDay = getWeekDay;
    function nextWeekday(date, days = 1, holidays = []) {
        const holidaySet = new Set(holidays);
        let result = next(date, days);
        let weekday = getWeekDay(result);
        while (weekday == 6 || weekday == 0 || holidaySet.has(result)) {
            result = next(result, weekday == 6 ? 2 : 1);
            weekday = getWeekDay(result);
        }
        return result;
    }
    Date.nextWeekday = nextWeekday;
    function span(date, relative) {
        return {
            years: getYear(date) - getYear(relative),
            months: getMonth(date) - getMonth(relative),
            days: getDay(date) - getDay(relative),
        };
    }
    Date.span = span;
    Date.epochStart = "0000-01-01";
    Date.epochEnd = "9999-12-31";
    function invert(date) {
        return `${(9999 - getYear(date)).toFixed(0).padStart(4, "0")}-${(13 - getMonth(date))
            .toFixed(0)
            .padStart(2, "0")}-${(32 - getDay(date)).toFixed(0).padStart(2, "0")}`;
    }
    Date.invert = invert;
})(Date || (Date = {}));
//# sourceMappingURL=Date.js.map